import sendReadReceiptOperation from 'owa-service/lib/operation/sendReadReceiptOperation';
import ItemId from 'owa-service/lib/contract/ItemId';

/**
 * This method makes service call for sending read receipt
 * @param itemId - itemId of the mail whose sender will receive the read receipt
 */
export default function sendReadReceipt(itemId: ItemId): Promise<boolean> {
    return sendReadReceiptOperation({ itemId });
}
